var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"filterable":false,"options":_vm.items,"label":"name","value":_vm.value,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"search":_vm.searchItems,"input":_vm.emitItem}},[_c('template',{slot:"no-options"},[_c('span',[_vm._v("Type to search items...")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d2f9242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigItemSearch.vue
// module id = null
// module chunks = 